import { useEffect, useState } from 'react';
import { healthReadyResponseSchema, type HealthReadyResponse } from '@gc/shared';

type Carga =
  | { readonly tipo: 'cargando' }
  | { readonly tipo: 'ok'; readonly datos: HealthReadyResponse }
  | { readonly tipo: 'error'; readonly mensaje: string };

/** Diagnóstico de dependencias. Health no va bajo /api/v1 ni devuelve {data}. */
export function Estado(): React.JSX.Element {
  const [carga, setCarga] = useState<Carga>({ tipo: 'cargando' });

  useEffect(() => {
    const controlador = new AbortController();
    fetch('/api/health/ready', { signal: controlador.signal })
      .then(async (respuesta) => {
        // Un 503 también trae cuerpo válido: interesa el detalle, no solo el código.
        setCarga({ tipo: 'ok', datos: healthReadyResponseSchema.parse(await respuesta.json()) });
      })
      .catch((causa: unknown) => {
        if (controlador.signal.aborted) return;
        setCarga({ tipo: 'error', mensaje: (causa as Error).message });
      });
    return () => controlador.abort();
  }, []);

  return (
    <section>
      <h1>Estado del sistema</h1>
      {carga.tipo === 'cargando' && <p role="status">Consultando…</p>}
      {carga.tipo === 'error' && <p role="alert">No se pudo contactar con la API: {carga.mensaje}</p>}
      {carga.tipo === 'ok' && (
        <>
          <p>
            Estado global: <strong>{carga.datos.status}</strong> (versión {carga.datos.version})
          </p>
          <ul>
            {carga.datos.checks.map((comprobacion) => (
              <li key={comprobacion.name}>
                {comprobacion.name}: <strong>{comprobacion.status}</strong>
                {comprobacion.detail ? ` — ${comprobacion.detail}` : ''}
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
